import React from 'react'
import { Switch } from 'react-router-dom'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_DEV_SETTINGS } from 'app-support/permissions/Permissions'
import { developerSettingsDashboardRoute } from 'routes/routeNames'
import DeveloperSettingsDashboard from 'app-support/developer-settings/DeveloperSettingsDashboard'

const enhance = withRegionSwitchHandler(developerSettingsDashboardRoute)

const DeveloperSettingsContainer: React.FC<{}> = () => (
  <Switch>
    <PermissionRoute
      permission={PERMISSION_DEV_SETTINGS}
      exact
      path={developerSettingsDashboardRoute}
      component={DeveloperSettingsDashboard}
    />
  </Switch>
)

export default enhance(DeveloperSettingsContainer)
